export default "__VITE_ASSET__DTYnG$Tg__"